angular.module('unica_grand_prix.grand_prix_controllers')

.controller('GrandPrixListController',
	function(
		$rootScope, $scope, $stateParams,
		$uibModal, $confirm,
		GrandPrixRankingListService, GrandPrixRankingSendService, GrandPrixRankingEditService
	) {

	$scope.invitation_list_id = $stateParams.invitation_list_id;
	$scope.event_id           = $stateParams.event_id;

	$rootScope.getEvent( $stateParams.event_id );
	$rootScope.getInvitationList( $stateParams.invitation_list_id );


	$scope.loadRankings = function() {
		$scope.showLoader();

		GrandPrixRankingListService
			.fullList( $rootScope.invitationListData.id )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.rankings = data;
				}
			});
	};


	$scope.$on( 'invitation_list_loaded', function() {
		$scope.loadRankings();
	});

	$scope.$on( 'event_loaded', function() {
		$scope.year = $rootScope.eventData.year;
	});


	$scope.toggleRankingSubRow = function(rankId)
	{
		angular.forEach($scope.rankings, function(rank, key) {
			if ( rank.id === rankId ) {
				rank.subrow = !rank.subrow;
				$scope.rankings[key] = rank;
			}
		});
	};


	$scope.openImportRankingsModal = function ()
	{
		var modalInstance = $uibModal.open({
			ariaLabelledBy:  'modal-title',
			ariaDescribedBy: 'modal-body',
			controller:      'ModalImportRankingsInstanceController',
			controllerAs:    '$ctrl',
			templateUrl:     './templates/modals/import-rankings.html',
			size:            'lg',
			windowClass:     'modal-rankings-list'
		});

		modalInstance.result.then(function (data) {
			if ( data.result === 'ok' ) {
				$scope.loadRankings();
			} else if ( data.result === 'ko' ) {
				$rootScope.showErrorMsg(data.message);
			}
		}, function () { });
	};


	$scope.openImportRecoversModal = function ()
	{
		var modalInstance = $uibModal.open({
			ariaLabelledBy:  'modal-title',
			ariaDescribedBy: 'modal-body',
			controller:      'ModalImportRecoversInstanceController',
			controllerAs:    '$ctrl',
			templateUrl:     './templates/modals/import-recovers.html',
			size:            'lg',
			windowClass:     'modal-recovers-list'
		});

		modalInstance.result.then(function (data) {
			if ( data.result === 'ok' ) {
				$scope.loadRankings();
			} else if ( data.result === 'ko' ) {
				$rootScope.showErrorMsg(data.message);
			}
		}, function () { });
	};

	$scope.sendGrandPrixList = function()
	{
		$confirm({
			title: 'Conferma Invio Pre-Inviti',
			text: 'Confermi l\'invio dei pre-inviti?'
		}).then(function() {

			$scope.showLoader();
			GrandPrixRankingSendService
				.send( $scope.invitation_list_id )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {
						$rootScope.getInvitationList( $stateParams.invitation_list_id );
						$scope.showSuccessMsg( data.sent + ' inviti inviati con successo!', '');
					}
				});

		}, function() {
			// Cancel
		});
	};


	$scope.unlockSession = function( id )
	{
		$confirm({
			title: 'Sei sicuro di voler sbloccare la sessione di questa agenzia?',
			text: 'Sei sicuro di voler sbloccare la sessione di questa agenzia?'
		}).then(function() {

			$scope.showLoader();

			GrandPrixRankingEditService
				.reset( id )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {
						$scope.loadRankings();

						$scope.showSuccessMsg('Sessione sbloccata con successo!', '');
					}
				});

		}, function() {
			// Cancel
		});
	};



	$scope.downloadExportGrandPrix = false;
	$scope.exportGrandPrixUrl      = '';

	$scope.prepareExportGrandPrixUrl = function() {
		$scope.showLoader();

		GrandPrixRankingListService
			.exportGrandPrix( $stateParams.invitation_list_id )
			.then(function(url) {
				$scope.hideLoader();

				if ( url ) {
					$scope.downloadExportGrandPrix = true;
					$scope.exportGrandPrixUrl      = url;
				}
			});
	};



	$scope.downloadExportGrandPrixAgencies = false;
	$scope.exportGrandPrixAgenciesUrl      = '';

	$scope.prepareExportGrandPrixAgenciesUrl = function() {
		$scope.showLoader();

		GrandPrixRankingListService
			.exportGrandPrixAgencies( $stateParams.invitation_list_id )
			.then(function(url) {
				$scope.hideLoader();

				if ( url ) {
					$scope.downloadExportGrandPrixAgencies = true;
					$scope.exportGrandPrixAgenciesUrl      = url;
				}
			});
	};


	$scope.downloadExportGrandPrixClick = false;
	$scope.exportGrandPrixClickUrl      = '';

	$scope.prepareExportGrandPrixClickUrl = function() {
		$scope.showLoader();

		GrandPrixRankingListService
			.exportGrandPrixClick( $stateParams.invitation_list_id )
			.then(function(url) {
				$scope.hideLoader();

				if ( url ) {
					$scope.downloadExportGrandPrixClick = true;
					$scope.exportGrandPrixClickUrl      = url;
				}
			});
	};
})

.controller('ModalImportRankingsInstanceController',
	function (
		$scope, $stateParams,
		$uibModalInstance, FileUploader, getBaseApiURL, Session
	) {


	$scope.importRankingsData = {
		csv: ''
	};


	$scope.formInvalid = true;


	$scope.uploader = new FileUploader({
		removeAfterUpload: true,
		alias: 'csv',
		url: getBaseApiURL + '/import/rankings/' + $stateParams.invitation_list_id,
		headers: {
			Authorization : 'Bearer ' + Session.token,
			Accept: 'application/json'
		}
	});


	$scope.uploader.onAfterAddingFile = function( fileItem ) {
		$scope.formInvalid = false;
	};


	$scope.uploader.onCompleteItem = function(fileItem, response) {
		$scope.hideLoader();
		$uibModalInstance.close( response );
	};


	$scope.deleteImportRankingsCsv = function() {
		angular.element(document.querySelector('.rankings_csv')).val(null);
	};


	$scope.importRankings = function () {
		$scope.showLoader();
		$scope.uploader.uploadAll();
	};


	$scope.closeModal = function() {
		$uibModalInstance.dismiss('cancel');
	};

})

.controller('ModalImportRecoversInstanceController',
	function (
		$scope, $stateParams,
		$uibModalInstance, FileUploader, getBaseApiURL, Session
	) {


	$scope.importRecoversData = {
		csv: ''
	};


	$scope.formInvalid = true;


	$scope.uploader = new FileUploader({
		removeAfterUpload: true,
		alias: 'csv',
		url: getBaseApiURL + '/import/recovers/' + $stateParams.invitation_list_id,
		headers: {
			Authorization : 'Bearer ' + Session.token,
			Accept: 'application/json'
		}
	});


	$scope.uploader.onAfterAddingFile = function( fileItem ) {
		$scope.formInvalid = false;
	};


	$scope.uploader.onCompleteItem = function(fileItem, response) {
		$scope.hideLoader();
		$uibModalInstance.close( response );
	};


	$scope.deleteImportRecoversCsv = function() {
		angular.element(document.querySelector('.recovers_csv')).val(null);
	};


	$scope.importRecovers = function () {
		$scope.showLoader();
		$scope.uploader.uploadAll();
	};


	$scope.closeModal = function() {
		$uibModalInstance.dismiss('cancel');
	};

});